<template>
  <reset-password-component
    :user-email="userEmail"
    :is-loading="isLoading"
    @updatePassword="updatePassword"
  />
</template>

<script>
import axios from '@/component/axios'
import jwtDefaultConfig from '@core/auth/jwt/jwtDefaultConfig'
import ResetPasswordComponent from './ResetPasswordComponent.vue'

export default {
  components: {
    ResetPasswordComponent,
  },
  data() {
    return {
      userEmail: '',
      isLoading: false,
    }
  },
  created() {
    this.userEmail = (this.$route.query.email || '').trim()
    if (!this.userEmail) {
      this.$router.replace({ name: 'auth-forgot-password' })
    }
  },
  methods: {
    async updatePassword(password, confirmPassword) {
      this.isLoading = true
      try {
        const res = await axios.put(jwtDefaultConfig.resetPasswordEndpoint, {
          email: this.userEmail,
          otp: (this.$route.query.otp || '').trim(),
          password,
          confirm_password: confirmPassword,
        })
        if (res.data?.status_code === 200 || res.data?.success) {
          this.$router.push({ name: 'auth-login' })
        } else {
          this.showError(res.data?.message || 'Unable to reset password')
        }
      } catch (error) {
        this.showError(error.response?.data?.message || 'Unable to reset password')
      } finally {
        this.isLoading = false
      }
    },
    showError(message) {
      this.$swal({
        title: 'Error',
        text: message,
        icon: 'error',
        timer: 2800,
        showConfirmButton: false,
      })
    },
  },
}
</script>
